module.exports = __webpack_public_path__ + "img/poster_n-a.6ee3914a.jpg";